/**
 * @file
 * Splide carousel behaviors.
 */

(function (Drupal, once) {
  'use strict';

  /**
   * Adds 'has-arrows' class to view header if splide arrows are visible.
   */
  Drupal.behaviors.splideViewArrows = {
    attach: function (context, settings) {
      // Find all splide view blocks
      const splideBlocks = once('splide-arrows-detector', '.splide-view-block', context);

      splideBlocks.forEach(function (block) {
        const viewHeader = block.querySelector('.view-header');
        const viewContent = block.querySelector('.view-content');

        // Check if both header and content exist
        if (!viewHeader || !viewContent) {
          return;
        }

        // Look for the splide container
        const splideContainer = viewContent.querySelector('.splide');

        if (!splideContainer) {
          return;
        }

        // Check if splide has arrows visible (doesn't have .is-less class)
        // .is-less is added when there are fewer items than perPage setting
        if (!splideContainer.classList.contains('is-less')) {
          viewHeader.classList.add('has-arrows');
        }
      });
    }
  };

  /**
   * Toggles 'is-at-start' and 'is-at-end' classes for fading frames on sliders with optionset "carousel-cards".
   */
  Drupal.behaviors.splideFadingFrames = {
    attach: function (context, settings) {
      const fadingSplides = once('splide-fading-frames', '[class*="splide--optionset--carousel-cards"]', context);

      fadingSplides.forEach(function (splideElement) {
        let splideInstance = splideElement.splide;

        // Function to update the fading classes
        const updateStatus = () => {
          let isAtStart = false;
          let isAtEnd = false;
          let statusSource = 'none';

          // Strategy 1: Use Splide Instance if available
          if (splideInstance) {
            statusSource = 'instance';
            isAtStart = (splideInstance.index === 0);

            // Calculate end index
            let endIndex = splideInstance.length - 1;
            if (splideInstance.Components && splideInstance.Components.Controller) {
              endIndex = splideInstance.Components.Controller.getEnd();
            }
            isAtEnd = (splideInstance.index >= endIndex);
          }
          // Strategy 2: Check Arrow Buttons state (Fallback)
          else {
            statusSource = 'dom-arrows';
            // Look for arrows inside the component

            // 1. Try specific custom classes (highest priority if explicit)
            let prevArrow = splideElement.querySelector('.splide__arrow-custom--prev');
            let nextArrow = splideElement.querySelector('.splide__arrow-custom--next');

            // 2. Strategy: Find container then look for loose matches (user request)
            if (!prevArrow || !nextArrow) {
              const arrowsContainer = splideElement.querySelector('[class*="splide__arrows"]');
              if (arrowsContainer) {
                // Look for btn with prev/next in class
                if (!prevArrow) prevArrow = arrowsContainer.querySelector('.btn[class*="prev"], [class*="prev"]');
                if (!nextArrow) nextArrow = arrowsContainer.querySelector('.btn[class*="next"], [class*="next"]');
              }
            }

            // 3. Fallback: Standard Splide selectors
            if (!prevArrow) prevArrow = splideElement.querySelector('.splide__arrow--prev');
            if (!nextArrow) nextArrow = splideElement.querySelector('.splide__arrow--next');

            if (prevArrow && nextArrow) {
              // Splide disables arrows when at boundaries (either disabled property or attribute)
              isAtStart = prevArrow.disabled || prevArrow.hasAttribute('disabled') || prevArrow.classList.contains('is-disabled');
              isAtEnd = nextArrow.disabled || nextArrow.hasAttribute('disabled') || nextArrow.classList.contains('is-disabled');
            } else {
              statusSource = 'failed-no-arrows';
            }
          }

          // Toggle classes on the Splide element itself
          if (isAtStart) {
            splideElement.classList.add('is-at-start');
          } else {
            splideElement.classList.remove('is-at-start');
          }

          if (isAtEnd) {
            splideElement.classList.add('is-at-end');
          } else {
            splideElement.classList.remove('is-at-end');
          }


          // // Debug Logging (Uncomment to troubleshoot)
          // console.log('Splide Fading Frames Update:', {
          //   id: splideElement.id,
          //   source: statusSource,
          //   isAtStart,
          //   isAtEnd,
          //   instanceFound: !!splideInstance
          // });

        };

        // Attach listeners to the Splide instance
        const attachInstanceEvents = () => {
          if (splideInstance && !splideInstance._fadingFramesAttached) {
            splideInstance.on('mounted updated move moved scroll', function () {
              updateStatus();
            });
            splideInstance._fadingFramesAttached = true; // Prevent double attachment
            // console.log('Attached Splide instance events');
          }
        };

        // Try to find the instance in global registry if not on element
        const findInstance = () => {
          // Direct property check
          if (splideElement.splide) {
            splideInstance = splideElement.splide;
            attachInstanceEvents();
            // console.log('Found Splide instance via direct property');
            return;
          }

          if (window.Splide && window.Splide.instances) {
            // Lookup by ID
            if (splideElement.id && window.Splide.instances[splideElement.id]) {
              splideInstance = window.Splide.instances[splideElement.id];
              attachInstanceEvents();
              // console.log('Found Splide instance via ID:', splideElement.id);
              return;
            }

            // Reverse Lookup: Iterate all instances to find matching root
            // This handles cases where ID is missing or mismatched
            try {
              for (const key in window.Splide.instances) {
                const instance = window.Splide.instances[key];
                if (instance && instance.root === splideElement) {
                  splideInstance = instance;
                  attachInstanceEvents();
                  // console.log('Found Splide instance via Root element matching');
                  return;
                }
              }
            } catch (e) {
              console.warn('Error searching Splide instances', e);
            }
          }
        };

        // Attempt to find instance immediately
        findInstance();
        updateStatus();

        // Listen to Splide events on the DOM element (as backup/bootstrapper)
        const events = ['splide:mounted', 'splide:updated', 'splide:move', 'splide:moved', 'splide:scroll'];

        events.forEach(function (evt) {
          // Listen on the inner splide element where events are actually emitted
          splideElement.addEventListener(evt, function () {
            if (!splideInstance) findInstance();
            updateStatus();
          });
        });

        // Polling fallback to find instance or check arrow state changes
        let checkCount = 0;
        const checkInterval = setInterval(function () {
          if (!splideInstance) findInstance();
          updateStatus();
          checkCount++;
          // Stop polling after 2 seconds if not found, or immediately if found (keep listening to events)
          if (checkCount > 20) clearInterval(checkInterval);
        }, 100);
      });
    }
  };

})(Drupal, once);